@let link = routeLink(); @if(link != null) { @if (link.routerLink != null) {
<a
    [routerLink]="link.routerLink"
    [queryParams]="link.routerLinkParams"
    [style.padding-left.px]="paddingLeft()"
    [style.padding-right.px]="paddingRight()"
    [class]="styleClasses()"
    (click)="_onRouteClick(link)"
    class="list-item"
    [target]="link.openInNewTab ? '_blank' : '_self'"
>
    <ng-container *ngTemplateOutlet="projectedContent"></ng-container>
    @if (itemType() === 'external-link') {
    <span class="external-link" [class]="theme()"></span>
    }
</a>
} @else {
<a
    [href]="link.url"
    [style.padding-left.px]="paddingLeft()"
    [style.padding-right.px]="paddingRight()"
    [class]="styleClasses()"
    (click)="_onRouteClick(link)"
    class="list-item"
    [target]="link.openInNewTab ? '_blank' : '_self'"
>
    <ng-container *ngTemplateOutlet="projectedContent"></ng-container>
    @if (itemType() === 'external-link') {
    <span class="external-link" [class]="theme()"></span>
    }
</a>
} } @else {
<div class="list-item" [class]="styleClasses()" [style.padding-left.px]="paddingLeft()" [style.padding-right.px]="paddingRight()" (click)="_onClick()">
    <!-- <ng-container *ngTemplateOutlet="projectedContent"></ng-container> -->
    {{ itemText() }}
</div>
}
<ng-template #projectedContent>
    <ng-content select="[contentForListItem]"></ng-content>
</ng-template>
